import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Nav, Button } from "react-bootstrap";
import { Tooltip } from 'antd';

import SummaryReport from "../../modules/ecs/components/SummaryReport";
import ViewReport from "../../modules/ecs/components/ViewReport";
import RequestNewScanECS from "../../modules/ecs/components/RequestNewScan";

import RSViewReport from "../../modules/rhymscan/components/ViewReport";
import RSRequestNewScan from "../../modules/rhymscan/components/RequestNewScan";

import VAPTRequestNewScan from "../../modules/vapt/components/RequestNewScan";
import ViewReportVAPT from "modules/vapt/components/SummaryReport";
import ViewReportPage from "modules/vapt/components/ViewReport";

import { fetchDimensions as fetchDimensionsService } from "../../services/modules/ecs/data";
import { fetchRSDimensions as fetchRSDimensionsService } from "../../services/modules/rhymscan/data";
import {
  fetchVAPTDimensions as fetchVAPTDimensionsService,
  fetchDimensionsVAPT as fetchCategoriesService,
} from "services/modules/vapt/data";
import { fetchCompanySpecificVAPTDimensions as fetchCompanyDimensionsService } from "services/modules/vapt/data";
import { fetchCloudTypes as fetchCloudTypesService } from "services/modules/vapt/alert";

import SubMenu from "./SubMenu";

import classNames from "classnames";

import { Dialog, DialogActions, DialogTitle, Divider } from "@mui/material";
import { PiGearFill } from "react-icons/pi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ArrowLeftTwoTone from '@mui/icons-material/ArrowLeftTwoTone';

import {
  faBug,
  faBuilding,
  faChartBar,
  faClipboardList,
  faCompass,
  faCopy,
  faEye,
  faFileInvoice,
  faFileUpload,
  faGlobe,
  faListAlt,
  faShieldAlt,
  faStar,
  faTachometerAlt,
  faTasks,
  faTh,
  faTimes,
  faUnlockAlt,
  faCogs,
  faSlidersH,
  faCube,
  faCog,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import { setMainItem, setSideBar } from "stores/modules/idp/authreducer";
import { fetchAgents } from "services/modules/soc/agent";
import DownloadSOCReport from "modules/soc/components/DownloadReport";


const SideBar = ({ isOpen, toggle }) => {
  // State variables
  const [cap, setCap] = useState(false);
  const [chooseDialog, setChooseDialog] = useState(false);
  const [ecs, setEcs] = useState(false);
  const [vapt, setVapt] = useState(false);
  const [isRequestNewScanOpen, setIsRequestNewScanOpen] = useState(false);
  const [isRsRequestNewScanOpen, setRsIsRequestNewScanOpen] = useState(false);
  const [isRsViewReportOpen, setRsIsViewReportOpen] = useState(false);
  const [isSummaryReportOpen, setIsSummaryReportOpen] = useState(false);
  const [isViewReportOpen, setIsViewReportOpen] = useState(false);
  const [isVAPTRequestNewScanOpen, setVAPTIsRequestNewScanOpen] = useState(
    false
  );
  const [isVAPTSummaryReportOpen, setVAPTIsSummaryReportOpen] = useState(false);
  const [isVAPTViewReportOpen, setVAPTIsViewReportOpen] = useState(false);
  const [isSOCReportDownload, setIsSOCReportDownlaod] = useState(false);
  const [loginuser, setLoginUser] = useState("");
  const [options, setOptions] = useState([]);
  const [rhymscan, setRhymScan] = useState(false);
  const [soc, setSoc] = useState(false);
  const [rsOptions, setRsOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);


  // Redux selectors
  const getAuthenticatedUserContainer = useSelector((state) => state.auth.user);
  const dimensionsContainer = useSelector((state) => state.ecsData.dimensions);
  const rsDimensionsContainer = useSelector((state) => state.rsData.dimensions);
  const vaptCategoriesContainer = useSelector(
    (state) => state.vaptData.vaptDimensions
  );
  const selectedCompanyContainer = useSelector(
    (state) => state.auth.companyData
  );
  const companyDimensionsContainer = useSelector(
    (state) => state.vaptData.companyDimensions
  );
  const activeMainItem = useSelector((state) => state.auth.mainItem);
  const agentsContainer = useSelector((state) => state.socData.agents);

  const params = { company: selectedCompanyContainer?.companyid };

  const selectedOptions = [ecs, cap, rhymscan, vapt];
  const isIntegratedDashboard = selectedOptions.filter(option => option === true).length >= 2;

  // React router
  const navigate = useNavigate();

  // Redux dispatch
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCloudTypesService());
    if (ecs) {
      dispatch(fetchDimensionsService({}));
    }
    if (rhymscan) {
      dispatch(fetchRSDimensionsService({}));
    }
    if (vapt) {
      dispatch(fetchCategoriesService({}));
      dispatch(fetchVAPTDimensionsService({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ecs, rhymscan, vapt]);

  useEffect(() => {
    if (vapt && selectedCompanyContainer?.companyid !== null) {
      dispatch(fetchCompanyDimensionsService({ params }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vapt, selectedCompanyContainer?.companyid]);

  useEffect(() => {
    getOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensionsContainer]);



  useEffect(() => {
    getRSOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rsDimensionsContainer]);

  useEffect(() => {
    getVAPTOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vaptCategoriesContainer]);

  useEffect(() => {
    if (soc && selectedCompanyContainer.soc_group !== undefined && selectedCompanyContainer.soc_env !== undefined) {
      dispatch(fetchAgents({
        sort: 'id',
        group: selectedCompanyContainer?.soc_group,
        soc_env: selectedCompanyContainer?.soc_env
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [soc, selectedCompanyContainer?.soc_group]);

  useEffect(() => {
    if (vapt && companyDimensionsContainer?.length > 0) {
      const filtered = companyDimensionsContainer?.map((dim) => dim.label);
      filtered.push("Overall");
      filtered.push("Cloud");
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyDimensionsContainer]);

  useEffect(() => {
    if (
      getAuthenticatedUserContainer &&
      getAuthenticatedUserContainer.company &&
      getAuthenticatedUserContainer.company.applications
    ) {
      setLoginUser(getAuthenticatedUserContainer.roles[0].label);
      for (const application of getAuthenticatedUserContainer.company
        .applications) {
        if (application.slug === "crs") {
          setEcs(true);
        } else if (application.slug === "cap") {
          setCap(true);
        }
        else if (application.slug === "rhymscan") {
          setRhymScan(true);
        } else if (application.slug === "vapt") {
          setVapt(true);
        }
        else if (application.slug === 'soc') {
          setSoc(true)
        }
      }
    }
  }, [getAuthenticatedUserContainer]);

  const handleconfigureMainItemClick = (mainItemKey) => {
    if (loginuser === "Super Admin") {
      if (ecs === true) {
        handleMainItemClick(mainItemKey, "/crs/configure-dimensions-ecs");
      } else if (cap === true) {
        handleMainItemClick(mainItemKey, "/cap/configurestandards");
      }
      else if (rhymscan === true) {
        handleMainItemClick(mainItemKey, "/rs/configure-dimensions-rs");
      }
    } else if (loginuser === "Admin") {
      if (cap === true) {
        handleMainItemClick(mainItemKey, "/cap/adm-configurestandards");
      }
    }

  };
  const handleMainItemClick = (mainItemKey, route) => {
    dispatch(setMainItem(mainItemKey));
    if (route) {
      navigate(route);
    }
  };

  // const handleSubItemClick = (mainItemKey) => {
  //   dispatch(setSideBar(mainItemKey));
  // };

  const handleBackToMainMenu = () => {
    dispatch(setMainItem(null));
    dispatch(setSideBar(null));
    if (loginuser === "Super Admin" || loginuser === "Admin") {
      if (window.location.pathname !== "/companies") {
        navigate("/companies");
      }
    }
    else
      navigate("/integrated-dashboard");
  };

  useEffect(() => {
    const handlePopState = () => {
      // This function is called when the user uses the browser's back or forward button
      const currentPath = window.location.pathname;
      if (currentPath === "/companies" || currentPath === "/integrated-dashboard") {
        dispatch(setMainItem(null));
        dispatch(setSideBar(null));
      }
    };

    // Listen for the popstate event
    window.addEventListener("popstate", handlePopState());

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handlePopState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const handleSelect = (key) => {
    setSelectedItem(key);
  };

  // Method sets the ECS dimensions to options
  const getOptions = () => {
    setOptions([]);
    let optionslist = [];
    if (getAuthenticatedUserContainer && getAuthenticatedUserContainer.roles) {
      optionslist.push({
        key: "over-all",
        route: "/crs/dashboard/over-all",
        title: "Overall",
        icon: "/assets/icons/over-all.svg",
        activeIcon: "img:/assets/icons/over-all-active.svg",
      });
      dimensionsContainer
        .filter((dim) => !!dim.subDimensions)
        .forEach((dim) => {
          optionslist.push({
            key: dim.slug,
            route: `/crs/dashboard/${dim.slug}`,
            title: dim.label,
            icon: `/assets/icons/${dim.slug}.svg`,
            activeIcon: `img:/assets/icons/${dim.slug}-active.svg`,
          });
        });
      optionslist.push({
        key: "compliance",
        route: "/crs/dashboard/compliance",
        title: "Compliance",
        icon: "/assets/icons/compliance.svg",
        activeIcon: "img:/assets/icons/compliance-active.svg",
      });
    }
    setOptions(optionslist);
  };

  // Method sets the RS dimensions to options
  const getRSOptions = () => {
    setRsOptions([]);
    let optionslist = [];
    if (getAuthenticatedUserContainer && getAuthenticatedUserContainer.roles) {
      optionslist.push({
        key: "over-all",
        route: "/rs/dashboard/over-all",
        title: "Overall",
        icon: "/assets/icons/over-all.svg",
        activeIcon: "img:/assets/icons/over-all-active.svg",
      });
      rsDimensionsContainer
        .filter((dim) => !!dim.subDimensions)
        .forEach((dim) => {
          optionslist.push({
            key: dim.slug,
            route: `/rs/dashboard/${dim.slug}`,
            title: dim.label,
            icon: `/assets/icons/${dim.slug}.svg`,
            activeIcon: `img:/assets/icons/${dim.slug}-active.svg`,
          });
        });
    }
    setRsOptions(optionslist);
  };

  const populateOptions = (categoryKey) => {
    const options = [];
    const category = vaptCategoriesContainer?.find(
      (dim) => dim.slug === categoryKey
    );
    if (getAuthenticatedUserContainer && getAuthenticatedUserContainer.roles) {
      options.push({
        key: "over-all",
        route: `/vapt/dashboard/over-all?category=${categoryKey}`,
        title: "Overall",
        icon: "/assets/icons/over-all.svg",
        activeIcon: "img:/assets/icons/over-all-active.svg",
      });

      category?.Dimensions?.forEach((dim) => {
        options.push({
          key: dim.slug,
          route: `/vapt/dashboard/${dim.slug}?category=${categoryKey}&dimension=${dim.slug}`,
          title: dim.label,
          icon: `/assets/icons/over-all.svg`,
          activeIcon: `img:/assets/icons/${dim.slug}-active.svg`,
          id: dim.id,
        });
      });
    }

    return options;
  };

  // Method sets the VAPT dimensions to options
  const getVAPTOptions = () => {
    populateOptions("web-application");
    populateOptions("mobile");
    populateOptions("network");
    populateOptions("aws-security");
    populateOptions("gcp-security");
    populateOptions("azure-security");
  };

  return (
    <div className={classNames("sidebar sticky", { "is-open": isOpen })} >
      <div className="sidebar-header">
        <Button
          variant="link"
          onClick={toggle}
          style={{ color: "#fff" }}
          className="mt-4"
        >
          <FontAwesomeIcon icon={faTimes} pull="right" size="xs" />
        </Button>
        <h3>RHYM</h3>
        {activeMainItem !== null && (
          <h6 onClick={handleBackToMainMenu} style={{ color: "white", cursor: 'pointer' }}>
            <ArrowLeftTwoTone style={{ fontSize: '30px' }} />
            Back To Main Menu
          </h6>
        )}
      </div>

      <Nav
        className="flex-column pt-2"
        onSelect={(key) => setSelectedItem(key)}
        activeKey={selectedItem}
      >
        {(activeMainItem === null ||
          activeMainItem === "integrated-dashboard") &&
          isIntegratedDashboard
          &&
          loginuser !== "Super Admin" &&
          loginuser !== "Analyst" && (
            <span>
              <Nav.Item key="integrated-dashboard">
                <Nav.Link
                  as={Link}
                  to="/integrated-dashboard"
                >
                  <FontAwesomeIcon icon={faTachometerAlt} />
                  <span className="pl-1"> Integrated Dashboard </span>
                </Nav.Link>
              </Nav.Item>
            </span>
          )}
        {(activeMainItem === null || activeMainItem === "company") &&
          (loginuser === "Admin" ||
            loginuser === "Super Admin" ||
            loginuser === "Analyst") && (
            <span>

              {(activeMainItem === "company") && (
                <SubMenu
                  title={<span className="px-2">Company</span>}
                  icon={faBuilding}
                  onClick={() => handleMainItemClick("company")}
                  expand="false"
                  items={[
                    <Nav
                      className="flex-column pt-2"
                      onSelect={(key) => setSelectedItem(key)}
                      activeKey={selectedItem}
                    >
                      {loginuser === "Admin" && (
                        <span>
                          <Nav.Item key="addcompany">
                            <Nav.Link as={Link} to="/add-company">
                              <FontAwesomeIcon
                                icon={faBuilding}
                                className="mr-2"
                              />
                              <span className="px-1"> Add Company </span>
                            </Nav.Link>
                          </Nav.Item>
                        </span>
                      )}
                      {loginuser === "Super Admin" && (
                        <span>
                          <Nav.Item key="AddPartnerCompany">
                            <Nav.Link
                              as={Link}
                              onClick={() => setChooseDialog(true)}
                            >
                              <FontAwesomeIcon
                                icon={faBuilding}
                                className="mr-2"
                              />
                              <span className="px-1"> Add Company </span>
                            </Nav.Link>
                          </Nav.Item>
                        </span>

                      )}

                      <Nav.Item key="companies">
                        <Nav.Link as={Link} to="/companies">
                          <FontAwesomeIcon icon={faBuilding} className="mr-2" />
                          <span className="px-1"> Companies </span>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                  ]}
                />
              )}

              {(activeMainItem === null) && (
                <SubMenu
                  title={<span className="px-2">Company</span>}
                  icon={faBuilding}
                  onClick={() => handleMainItemClick("company")}
                  expand="false"
                  items={[]}
                />
              )}

            </span>
          )}
        {(activeMainItem === null || activeMainItem === "Configure") && (
          <>
            {(loginuser === "Super Admin" || loginuser === "Admin") && (
              <>
                <span>
                  <SubMenu
                    title={
                      <Tooltip title="ISP Configurator" placement="top">
                        <span className="px-2">Configurator</span>
                      </Tooltip>
                    }
                    onClick={() => handleconfigureMainItemClick("Configure")}
                    expand="false"
                    icon={faCogs}
                    items={[
                      <>
                        {(getAuthenticatedUserContainer?.company?.applications?.length > 1) && (<span>
                          <Nav.Item key="configureserviceweightagecontrol">
                            <Nav.Link as={Link} to="/update-service-weightage">
                              <PiGearFill />
                              <span className="px-1"> ISP Weightage</span>
                            </Nav.Link>
                          </Nav.Item>
                        </span>)}
                        {(ecs === true && loginuser === "Super Admin") && (
                          <span>
                            <SubMenu
                              title={
                                <span>
                                  <FontAwesomeIcon icon={faTh} />
                                  <span className="px-1">ECS Configurator</span>
                                </span>
                              }
                              items={[
                                <Nav
                                  className="flex-column pt-2"
                                  onSelect={(key) => setSelectedItem(key)}
                                  activeKey={selectedItem}
                                >

                                  {(loginuser === "Super Admin") && (
                                    <>
                                      <span>
                                        <Nav.Item key="configuredimensionsECS">
                                          <Nav.Link as={Link} to="/crs/configure-dimensions-ecs">
                                            <FontAwesomeIcon icon={faSlidersH} />
                                            <span className="px-1">Configurator Dimensions </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>
                                        <Nav.Item key="dimensionsweightageECS">
                                          <Nav.Link as={Link} to="/crs/dimensions-weightage-ecs">
                                            <FontAwesomeIcon icon={faCog} />
                                            <span className="px-1">Dimensions Weightages</span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                    </>
                                  )}



                                </Nav>,
                              ]}
                            />
                          </span>
                        )}
                        {(rhymscan === true && loginuser === "Super Admin") && (
                          <span>
                            <SubMenu
                              title={
                                <span>
                                  <FontAwesomeIcon icon={faTh} />
                                  <span className="px-1">Rhymscan Configurator</span>
                                </span>
                              }
                              items={[
                                <Nav
                                  className="flex-column pt-2"
                                  onSelect={(key) => setSelectedItem(key)}
                                  activeKey={selectedItem}
                                >
                                  {(loginuser === "Super Admin") && (
                                    <>
                                      <span>
                                        <Nav.Item key="configuredimensionsRS">
                                          <Nav.Link as={Link} to="/rs/configure-dimensions-rs">
                                            <FontAwesomeIcon icon={faSlidersH} />
                                            <span className="px-1">Configurator Dimensions </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>
                                        <Nav.Item key="dimensionsweightageRS">
                                          <Nav.Link as={Link} to="/rs/dimensions-weightage-rs">
                                            <FontAwesomeIcon icon={faCog} />
                                            <span className="px-1">Dimensions Weightages</span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                    </>
                                  )}


                                </Nav>,
                              ]}
                            />
                          </span>
                        )}
                        {cap === true && ((loginuser === "Super Admin" || loginuser === "Admin")) && (
                          <span>
                            <SubMenu
                              title={
                                <span>
                                  <FontAwesomeIcon icon={faTh} />
                                  <span className="px-1">CAP Configurator</span>
                                </span>
                              }
                              items={[
                                <Nav
                                  className="flex-column pt-2"
                                  onSelect={(key) => setSelectedItem(key)}
                                  activeKey={selectedItem}
                                >
                                  {loginuser === "Super Admin" && (
                                    <>
                                      <span>
                                        
                                        <Nav.Item key="configurestandards">
                                          <Nav.Link as={Link} to="/cap/configurestandards">
                                            <FontAwesomeIcon icon={faCube} />
                                            <span className="px-1">Master Standard </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>
                                        
                                        <Nav.Item key="configurecontrols">
                                          <Nav.Link as={Link} to="/cap/configurecontrols">
                                            <FontAwesomeIcon icon={faCube} />
                                            <span className="px-1">Master Control </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>       
                                        <Nav.Item key="configurecontrolsweightages">
                                          <Nav.Link as={Link} to="/cap/configurecontrolsweightages">
                                            <FontAwesomeIcon icon={faCube} />
                                            <span className="px-1">Master Controls Weightages </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                      
                                        <Nav.Item key="configurequestions">
                                          <Nav.Link as={Link} to="/cap/configurequestions">
                                            <FontAwesomeIcon icon={faCube} />
                                            <span className="px-1">Master Subcontrol, Question </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                     
                                        <Nav.Item key="adm-configurestandards">
                                          <Nav.Link as={Link} to="/cap/adm-configurestandards">
                                            <FontAwesomeIcon icon={faBook} />
                                            <span className="px-1">Standard </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                    
                                        <Nav.Item key="adm-configurecontrol">
                                          <Nav.Link as={Link} to="/cap/adm-configurecontrol">
                                            <FontAwesomeIcon icon={faBook} />
                                            <span className="px-1">Control </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                       
                                        <Nav.Item key="adm-configurecontrolsweightages">
                                          <Nav.Link as={Link} to="/cap/adm-configurecontrolsweightages">
                                            <FontAwesomeIcon icon={faBook} />
                                            <span className="px-1">Controls Weightages </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                       
                                        <Nav.Item key="adm-configurequestion">
                                          <Nav.Link as={Link} to="/cap/adm-configurequestion">
                                            <FontAwesomeIcon icon={faBook} />
                                            <span className="px-1">Subcontrol, Question </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                    </>
                                  )}
                                  {loginuser === "Admin" && (
                                    <>
                                      <span>                                       
                                        <Nav.Item key="adm-configurestandards">
                                          <Nav.Link as={Link} to="/cap/adm-configurestandards">
                                            <PiGearFill />
                                            <span className="px-1">Standard </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                       
                                        <Nav.Item key="adm-configurecontrol">
                                          <Nav.Link as={Link} to="/cap/adm-configurecontrol">
                                            <PiGearFill />
                                            <span className="px-1">Control </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                       
                                       <Nav.Item key="adm-configurecontrolsweightages">
                                          <Nav.Link as={Link} to="/cap/adm-configurecontrolsweightages">
                                            <PiGearFill />
                                            <span className="px-1">Controls Weightages </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>                                       
                                        <Nav.Item key="adm-configurequestion">
                                          <Nav.Link as={Link} to="/cap/adm-configurequestion">
                                            <PiGearFill />
                                            <span className="px-1">Subcontrol / Question </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                    </>
                                  )}
                                </Nav>,
                              ]}
                            />
                          </span>
                        )}
                        {(vapt === true && loginuser === "Super Admin") && (
                          <span>
                            <SubMenu
                              title={
                                <span>
                                  <FontAwesomeIcon icon={faTh} />
                                  <span className="px-1">VAPT Configurator</span>
                                </span>
                              }
                              items={[
                                <Nav
                                  className="flex-column pt-2"
                                  onSelect={(key) => setSelectedItem(key)}
                                  activeKey={selectedItem}
                                >
                                  {(loginuser === "Super Admin") && (
                                    <>
                                      <span>
                                        <Nav.Item key="configuredimensionsVAPT">
                                          <Nav.Link as={Link} to="/vapt/configure-dimensions-vapt">
                                            <FontAwesomeIcon icon={faSlidersH} />
                                            <span className="px-1">Configurator Dimensions </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                      <span>
                                        <Nav.Item key="dimensionsweightageVAPT">
                                          <Nav.Link as={Link} to="/vapt/dimensions-weightage-vapt">
                                            <FontAwesomeIcon icon={faCog} />
                                            <span className="px-1">Dimensions Weightages</span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      </span>
                                    </>
                                  )}
                                </Nav>,
                              ]}
                            />
                          </span>
                        )}
                        {(loginuser === "Super Admin") && (
                          <span>
                            <SubMenu
                              title={
                                <span>
                                  <FontAwesomeIcon icon={faTh} />
                                  <span className="px-1">Threat Intelligence Configurator</span>
                                </span>
                              }
                              items={[
                                <Nav
                                  className="flex-column pt-2"
                                  onSelect={(key) => setSelectedItem(key)}
                                  activeKey={selectedItem}
                                >
                                  <span>
                                    <Nav.Item key="viewAllThreatActors">
                                      <Nav.Link as={Link} to="/tip/view-threatactors">
                                        <FontAwesomeIcon icon={faBug} />
                                        <span className="px-1">View ThreatActors </span>
                                      </Nav.Link>
                                    </Nav.Item>
                                  </span>
                                </Nav>,
                              ]}
                            />
                          </span>
                        )}
                      </>
                    ]}
                  />
                </span>
              </>
            )}
          </>
        )}
        {(activeMainItem === null || activeMainItem === "externalview" || activeMainItem === "ecsdashboards" || activeMainItem === "ecsreportmanagement") &&
          ecs === true && (
            <span>
              <SubMenu
                title={
                  <Tooltip title="External Cyber Score" placement="top">
                    <span className="px-2">External View</span>
                  </Tooltip>
                }
                onClick={() =>
                  handleMainItemClick("externalview", "/crs/dashboard/over-all")
                }
                expand="false"
                icon={faCompass}
                items={[
                  <Nav
                    className="flex-column pt-2"
                    onSelect={(key) => setSelectedItem(key)}
                    activeKey={selectedItem}
                  >
                    {(loginuser === "Super Admin" ||
                      loginuser === "Admin" ||
                      loginuser === "Analyst") && (
                        <span>
                          <Nav.Item key="ecspartnerdashboard">
                            <Nav.Link as={Link} to="/crs/partner-dashboard">
                              <FontAwesomeIcon icon={faTh} />
                              <span className="px-1">Partner Dashboard </span>
                            </Nav.Link>
                          </Nav.Item>
                        </span>
                      )}
                    {options.length > 0 && (
                      <span>
                        <SubMenu
                          title={
                            <span>
                              <FontAwesomeIcon icon={faTh} />
                              <span className="px-1">Dashboards</span>
                            </span>
                          }
                          onClick={() => handleMainItemClick("ecsdashboards")}
                          appSlug="ecsdashboards"
                          items={[
                            <Nav
                              className="flex-column pt-2"
                              onSelect={(key) => setSelectedItem(key)}
                              activeKey={selectedItem}
                            >
                              {options.map((menuItem, index) => (
                                <span>
                                  <hr className="my-0" />
                                  <Nav.Item key={menuItem.key}>
                                    <Nav.Link  as={Link} to={menuItem.route}>
                                      <img
                                        src={menuItem.icon}
                                        className="nav-dimension-icon"
                                        alt=" "
                                      />
                                      {menuItem.title}
                                    </Nav.Link>
                                  </Nav.Item>
                                </span>
                              ))}
                            </Nav>,
                          ]}
                        />
                      </span>
                    )}
                    <span>
                      <SubMenu
                        title={
                          <span>
                            <FontAwesomeIcon icon={faClipboardList} />
                            <span className="px-1">ECS Reports</span>
                          </span>
                        }
                        items={[
                          <Nav
                            className="flex-column pt-2"
                            onSelect={(key) => setSelectedItem(key)}
                            activeKey={selectedItem}
                          >
                            <Nav.Item key="ecsviewreports">
                              <Nav.Link
                                onClick={() =>
                                  setIsViewReportOpen(!isViewReportOpen)
                                }
                              >
                                <FontAwesomeIcon icon={faEye} />
                                <span className="px-1"> View Report </span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item key="ecsrequestnewscan">
                              <Nav.Link
                                onClick={() =>
                                  setIsRequestNewScanOpen(!isRequestNewScanOpen)
                                }
                              >
                                <FontAwesomeIcon icon={faFileUpload} />
                                <span className="px-1"> Request New Scan </span>
                              </Nav.Link>
                            </Nav.Item>
                            {(loginuser === "Super Admin" ||
                              loginuser === "Analyst" ||
                              (getAuthenticatedUserContainer &&
                                getAuthenticatedUserContainer.company &&
                                getAuthenticatedUserContainer.company
                                  .ppt_report === "true")) && (
                                <span>
                                  <Nav.Item key="ecspdfreport">
                                    <Nav.Link
                                      onClick={() =>
                                        setIsSummaryReportOpen(
                                          !isSummaryReportOpen
                                        )
                                      }
                                    >
                                      <FontAwesomeIcon icon={faListAlt} />
                                      <span className="px-1">
                                        {" "}
                                        Summary Report{" "}
                                      </span>
                                    </Nav.Link>
                                  </Nav.Item>
                                </span>
                              )}
                          </Nav>,
                        ]}
                      />
                    </span>
                    {(loginuser === "Super Admin" ||
                      loginuser === "Analyst") && (
                        <SubMenu
                          title={
                            <span>
                              <FontAwesomeIcon icon={faTasks} />
                              <span className="px-1">Report Management</span>
                            </span>
                          }
                          onClick={() =>
                            handleMainItemClick("ecsreportmanagement")
                          }
                          appSlug="ecsreportmanagement"
                          items={[
                            <Nav
                              className="flex-column pt-2"
                              onSelect={(key) => setSelectedItem(key)}
                              activeKey={selectedItem}
                            >
                              <Nav.Item key="ecsrequestreports">
                                <Nav.Link as={Link} to="/crs/request-reports">
                                  <FontAwesomeIcon icon={faFileInvoice} />
                                  <span className="px-1"> Requested Report </span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item key="ecsuploadpptreports">
                                <Nav.Link as={Link} to="/crs/upload-ppt-reports">
                                  <FontAwesomeIcon icon={faFileUpload} />
                                  <span className="px-1">
                                    {" "}
                                    Upload PPT Reports{" "}
                                  </span>
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>,
                          ]}
                        />
                      )}
                  </Nav>,
                ]}
              />
            </span>
          )}
        {(activeMainItem === null || activeMainItem === "CAP") && cap === true && (
          <span>
            <SubMenu
              title={
                <Tooltip title="Compliance Assessment Platform" placement="top">
                  <span className="px-2">CAP</span>
                </Tooltip>
              }
              onClick={() => handleMainItemClick("CAP", "/cap/dashboard")}
              expand="false"
              icon={faShieldAlt}
              items={[
                <Nav
                  className="flex-column pt-2"
                  onSelect={(key) => setSelectedItem(key)}
                  activeKey={selectedItem}
                >
                  <Nav.Item key="capdashboard">
                    <Nav.Link as={Link} to="/cap/dashboard">
                      <FontAwesomeIcon icon={faTachometerAlt} />
                      <span className="px-1"> Dashboard </span>
                    </Nav.Link>
                  </Nav.Item>
                  {(getAuthenticatedUserContainer?.roles[0]?.permissions.includes('UPDATE_SELF_SELECTED_STANDARDS') ||
                    loginuser === "Super Admin") && (
                      <span>
                        <Nav.Item key="capstandards">
                          <Nav.Link as={Link} to="/cap/standards">
                            <FontAwesomeIcon icon={faStar} />
                            <span className="px-1"> Standards </span>
                          </Nav.Link>
                        </Nav.Item>
                      </span>
                    )}
                  {loginuser === "User" && (
                    <span>
                      <SubMenu
                        title={<span className="px-1">&nbsp;Assessments</span>}
                        icon={faCopy}
                        items={[
                          <Nav
                            className="flex-column pt-2"
                            onSelect={(key) => setSelectedItem(key)}
                            activeKey={selectedItem}
                          >
                            <Nav.Item key="capuserpendingassessments">
                              <Nav.Link
                                as={Link}
                                to="/cap/user-pendingassessments"
                              >
                                <span> Pending Assessments </span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item key="capusermitigationplan">
                              <Nav.Link as={Link} to="/cap/user-mitigationplan">
                                <span> Mitigation Plan </span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item key="capuserassessmentshistory">
                              <Nav.Link
                                as={Link}
                                to="/cap/user-assessmentshistory"
                              >
                                <span> Historical Assessments </span>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>,
                        ]}
                      />
                    </span>
                  )}
                  {(getAuthenticatedUserContainer?.roles[0].permissions.includes('CREATE_SELF_ASSESSMENT') ||
                    loginuser === "Super Admin") && (
                      <span>
                        <SubMenu
                          title={<span className="px-1">&nbsp;Assessments</span>}
                          icon={faCopy}
                          items={[
                            <Nav
                              className="flex-column pt-2"
                              onSelect={(key) => setSelectedItem(key)}
                              activeKey={selectedItem}
                            >
                              <Nav.Item key="capassignassessment">
                                <Nav.Link as={Link} to="/cap/assign-assessment">
                                  <span> Assign Assessment </span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item key="cappendingassessment">
                                <Nav.Link as={Link} to="/cap/pending-assessment">
                                  <span> Pending Assessments </span>
                                </Nav.Link>
                              </Nav.Item>     
                              <Nav.Item key="capmitigationplan">
                                <Nav.Link as={Link} to="/cap/mitigationplan">
                                  <span> Mitigation Plan </span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item key="capassessmentshistory">
                                <Nav.Link as={Link} to="/cap/assessments-history">
                                  <span> Historical Assessments </span>
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>,
                          ]}
                        />
                      </span>
                    )}    
                  <Nav.Item key="capuserguide">
                    <Nav.Link as={Link} to="/cap/userguide">
                      <FontAwesomeIcon icon={faGlobe} className="mr-2" />
                      <span className="px-1"> User Guide </span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>,
              ]}
            />
          </span>
        )}
        {(activeMainItem === null || activeMainItem === "RHYMScan" || activeMainItem === "rsdashboards" || activeMainItem === "rsreportmanagement") &&
          rhymscan === true && (
            <span>
              <SubMenu
                title={<span className="px-2">RHYMScan</span>}
                onClick={() =>
                  handleMainItemClick("RHYMScan", "/rs/dashboard/over-all")
                }
                icon={faBug}
                expand="false"
                items={[
                  <Nav
                    className="flex-column pt-2"
                    onSelect={(key) => setSelectedItem(key)}
                    activeKey={selectedItem}
                  >
                    {(loginuser === "Super Admin" ||
                      loginuser === "Admin" ||
                      loginuser === "Analyst") && (
                        <span>
                          <Nav.Item key="rs-partnerDashboard">
                            <Nav.Link as={Link} to="/rs/partner-dashboard">
                              <FontAwesomeIcon icon={faTh} />
                              <span className="px-1"> Partner Dashboard </span>
                            </Nav.Link>
                          </Nav.Item>
                        </span>
                      )}
                    {rsOptions.length > 0 && (
                      <span>
                        <SubMenu
                          title={
                            <span>
                              <FontAwesomeIcon icon={faTh} />
                              <span className="px-1">Dashboards</span>
                            </span>
                          }
                          onClick={() => handleMainItemClick("rsdashboards")}
                          appSlug="rsdashboards"
                          items={[
                            <Nav
                              className="flex-column pt-2"
                              onSelect={(key) => selectedItem(key)}
                              activeKey={selectedItem}
                            >
                              {rsOptions.map((menuItem, index) => (
                                <span>
                                  <hr className="my-0" />
                                  <Nav.Item key={menuItem.key}>
                                    <Nav.Link as={Link} to={menuItem.route}>
                                      <img
                                        src={menuItem.icon}
                                        className="nav-dimension-icon"
                                        alt="menuItem-icon"
                                      />
                                      {menuItem.title}
                                    </Nav.Link>
                                  </Nav.Item>
                                </span>
                              ))}
                            </Nav>,
                          ]}
                        />
                      </span>
                    )}
                    <span>
                      <SubMenu
                        title={
                          <span>
                            <FontAwesomeIcon icon={faClipboardList} />
                            <span className="px-1">RHYMScan Reports</span>
                          </span>
                        }
                        items={[
                          <Nav
                            className="flex-column pt-2"
                            onSelect={(key) => selectedItem(key)}
                            activeKey={selectedItem}
                          >
                            <Nav.Item key="rsviewreports">
                              <Nav.Link
                                onClick={() =>
                                  setRsIsViewReportOpen(!isRsViewReportOpen)
                                }
                              >
                                <FontAwesomeIcon icon={faEye} />
                                <span className="px-1"> View Report </span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item key="rsrequestnewscan">
                              <Nav.Link
                                onClick={() =>
                                  setRsIsRequestNewScanOpen(
                                    !isRsRequestNewScanOpen
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faFileUpload} />
                                <span className="px-1"> Request New Scan </span>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>,
                        ]}
                      />
                    </span>
                    {(loginuser === "Super Admin" ||
                      loginuser === "Analyst") && (
                        <SubMenu
                          title={
                            <span>
                              <FontAwesomeIcon icon={faTasks} />
                              <span className="px-1">Report Management</span>
                            </span>
                          }
                          onClick={() => handleMainItemClick("rsreportmanagement")}
                          appSlug="rsreportmanagement"
                          items={[
                            <Nav
                              className="flex-column pt-2"
                              onSelect={(key) => selectedItem(key)}
                              activeKey={selectedItem}
                            >
                              <Nav.Item key="rsrequestreports">
                                <Nav.Link as={Link} to="/rs/request-reports">
                                  <FontAwesomeIcon icon={faFileInvoice} />
                                  <span className="px-1"> Requested Report </span>
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>,
                          ]}
                        />
                      )}
                  </Nav>,
                ]}
              />
            </span>
          )}
        {(activeMainItem === null || activeMainItem === "VAPT" || activeMainItem === "vaptcategories" || activeMainItem === "vaptreportmanagement") &&
          vapt === true && (
            <span>
              <SubMenu
                title={
                  <Tooltip title="Vulnerability Analysis and Penetration Testing" placement="top">
                    <span className="px-2">VAPT</span>
                  </Tooltip>
                }
                onClick={() =>
                  handleMainItemClick("VAPT", "/vapt/dashboard/overall")
                }
                icon={faUnlockAlt}
                expand="false"
                items={[
                  <Nav
                    className="flex-column pt-2"
                    onSelect={(key) => setSelectedItem(key)}
                    activeKey={selectedItem}
                  >
                    {vaptCategoriesContainer?.length > 0 && (
                      <span>
                        <SubMenu
                          title={
                            <span>
                              <FontAwesomeIcon icon={faTh} />
                              <span className="px-1">Dashboards</span>
                            </span>
                          }
                          onClick={() => handleMainItemClick("vaptcategories")}
                          appSlug="vaptcategories"
                          items={[
                            <Nav
                              className="flex-column pt-2"
                              onSelect={(key) => setSelectedItem(key)}
                              activeKey={selectedItem}
                            >
                              <span>
                                <Nav.Item
                                  key="overall-vapt"
                                  style={{ position: "relative", left: "8px" }}
                                >
                                  <Nav.Link
                                    as={Link}
                                    to="/vapt/dashboard/overall"
                                  >
                                    <FontAwesomeIcon icon={faTasks} />
                                    <span className="px-1"> Overall </span>
                                  </Nav.Link>
                                </Nav.Item>
                              </span>
                              {companyDimensionsContainer?.map(
                                (dimension, index) => (
                                  <Nav.Item key={dimension?._id}>
                                    <Nav.Link>
                                      <SubMenu
                                        title={
                                          <>
                                            <FontAwesomeIcon icon={faTasks} />
                                            <span className="px-1">
                                              {dimension.label}
                                            </span>
                                          </>
                                        }
                                        items={[
                                          <Nav
                                            className="flex-column pt-2"
                                            onSelect={(key) =>
                                              setSelectedItem(key)
                                            }
                                            activeKey={selectedItem}
                                          >
                                            {dimension?.subcategories?.map(
                                              (menuItem, index) => (
                                                <span>
                                                  <hr className="my-0" />
                                                  <Nav.Item key={index}>
                                                    <Nav.Link>
                                                      <SubMenu
                                                        className="px-1"
                                                        title={
                                                          <>
                                                            <FontAwesomeIcon
                                                              icon={faTasks}
                                                            />
                                                            <span className="px-1">
                                                              {
                                                                menuItem.category
                                                              }
                                                            </span>
                                                          </>
                                                        }
                                                        items={[
                                                          <Nav
                                                            className="flex-column pt-2"
                                                            onSelect={(key) =>
                                                              setSelectedItem(
                                                                key
                                                              )
                                                            }
                                                            activeKey={
                                                              selectedItem
                                                            }
                                                          >
                                                            <span>
                                                              <hr className="my-0" />
                                                              <Nav.Item>
                                                                <Nav.Link
                                                                  as={Link}
                                                                  to={`/vapt/dashboard/over-all?category=${dimension?.slug}&subcategory=${menuItem?.category}`}
                                                                >
                                                                  <img
                                                                    src="/assets/icons/over-all.svg"
                                                                    className="nav-dimension-icon"
                                                                    alt="menuItem-icon"
                                                                  />
                                                                  Overall
                                                                </Nav.Link>
                                                              </Nav.Item>
                                                            </span>
                                                            {menuItem?.Dimensions?.map(
                                                              (dim, index) => (
                                                                <span>
                                                                  <hr className="my-0" />
                                                                  <Nav.Item
                                                                    key={dim.id}
                                                                  >
                                                                    <Nav.Link
                                                                      as={Link}
                                                                      to={`/vapt/dashboard/${dim?.slug}?category=${dimension?.slug}&subcategory=${menuItem?.category}&dimension=${dim?.slug}`}
                                                                    >
                                                                      <img
                                                                        src="/assets/icons/over-all.svg"
                                                                        className="nav-dimension-icon"
                                                                        alt="menuItem-icon"
                                                                      />
                                                                      {
                                                                        dim.label
                                                                      }
                                                                    </Nav.Link>
                                                                  </Nav.Item>
                                                                </span>
                                                              )
                                                            )}
                                                          </Nav>,
                                                        ]}
                                                      />
                                                    </Nav.Link>
                                                  </Nav.Item>
                                                </span>
                                              )
                                            )}
                                          </Nav>,
                                        ]}
                                      />
                                    </Nav.Link>
                                  </Nav.Item>
                                )
                              )}
                            </Nav>,
                          ]}
                        />
                      </span>
                    )}
                    <span>
                      <SubMenu
                        title={
                          <span>
                            <FontAwesomeIcon icon={faClipboardList} />
                            <span className="px-1">VAPT Reports</span>
                          </span>
                        }
                        items={[
                          <Nav
                            className="flex-column pt-2"
                            onSelect={(key) => setSelectedItem(key)}
                            activeKey={selectedItem}
                          >
                            <Nav.Item key="ecsviewreports">
                              <Nav.Link
                                onClick={() =>
                                  setVAPTIsViewReportOpen(!isVAPTViewReportOpen)
                                }
                              >
                                <FontAwesomeIcon icon={faEye} />
                                <span className="px-1"> View Report </span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item key="ecsrequestnewscan">
                              <Nav.Link
                                onClick={() =>
                                  setVAPTIsRequestNewScanOpen(
                                    !isVAPTRequestNewScanOpen
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faFileUpload} />
                                <span className="px-1"> Request New Scan </span>
                              </Nav.Link>
                            </Nav.Item>
                            {
                              (getAuthenticatedUserContainer &&
                                getAuthenticatedUserContainer.company
                              ) && (
                                <span>
                                  <Nav.Item key="ecspdfreport">
                                    <Nav.Link
                                      onClick={() =>
                                        setVAPTIsSummaryReportOpen(
                                          !isVAPTSummaryReportOpen
                                        )
                                      }
                                    >
                                      <FontAwesomeIcon icon={faListAlt} />
                                      <span className="px-1">
                                        {" "}
                                        Summary Report{" "}
                                      </span>
                                    </Nav.Link>
                                  </Nav.Item>
                                </span>
                              )}
                          </Nav>,
                        ]}
                      />
                    </span>
                    {(loginuser === "Super Admin" ||
                      loginuser === "Analyst") && (
                        <SubMenu
                          title={
                            <span>
                              <FontAwesomeIcon icon={faTasks} />
                              <span className="px-1">Report Management</span>
                            </span>
                          }
                          onClick={() =>
                            handleMainItemClick("vaptreportmanagement")
                          }
                          appSlug="vaptreportmanagement"
                          items={[
                            <Nav
                              className="flex-column pt-2"
                              onSelect={(key) => setSelectedItem(key)}
                              activeKey={selectedItem}
                            >
                              <Nav.Item key="vaptrequestreports">
                                <Nav.Link as={Link} to="/vapt/request-reports">
                                  <FontAwesomeIcon icon={faFileInvoice} />
                                  <span className="px-1"> Requested Report </span>
                                </Nav.Link>
                              </Nav.Item>
                              {(loginuser === "Super Admin" ||
                                loginuser === "Analyst" ||
                                (getAuthenticatedUserContainer &&
                                  getAuthenticatedUserContainer.company &&
                                  getAuthenticatedUserContainer.company
                                    .ppt_report === "true")) && (
                                  <span>
                                    <Nav.Item key="ecsuploadpptreports">
                                      <Nav.Link as={Link} to="/vapt/upload-pdf">
                                        <FontAwesomeIcon icon={faFileUpload} />
                                        <span className="px-1"> Upload PDF </span>
                                      </Nav.Link>
                                    </Nav.Item>
                                  </span>
                                )}
                            </Nav>,
                          ]}
                        />
                      )}
                  </Nav>,
                ]}
              />
            </span>
          )}
      </Nav>
      {(activeMainItem === null || activeMainItem === "soc") && (soc === true) && (
        <span>
          <SubMenu
            title={
              <Tooltip title="Security Operations Control" placement="top">
                <span className="px-2">SOC</span>
              </Tooltip>
            }
            onClick={() => handleMainItemClick("soc", "/soc/view-agents")}
            expand="false"
            icon={faCompass}
            items={[
              <Nav
                className="flex-column pt-2"
                onSelect={(key) => setSelectedItem(key)}
                activeKey={selectedItem}
              >
                <span>
                  <Nav.Item key="agents">
                    <Nav.Link as={Link} to="/soc/view-agents">
                      <FontAwesomeIcon icon={faTh} />
                      <span className="px-1">View Agents</span>
                    </Nav.Link>
                  </Nav.Item>
                </span>
                <span>
                  <SubMenu
                    title={
                      <span>
                        <FontAwesomeIcon icon={faTh} />
                        <span className="px-1">Dashboards</span>
                      </span>
                    }
                    onClick={() => handleMainItemClick("soc", "/soc/overall-dashboard")}
                    className="ml-1"
                    appSlug="socdashboards"
                    items={[
                      <Nav
                        className="flex-column pt-2"
                        onSelect={(key) => setSelectedItem(key)}
                        activeKey={selectedItem}
                      >
                        <span>
                          <Nav.Item
                            key="overall-vapt"
                          >
                            <Nav.Link
                              as={Link}
                              to="/soc/overall-dashboard"
                            >
                              <FontAwesomeIcon icon={faTasks} />
                              <span className="px-1">&nbsp;Overall </span>
                            </Nav.Link>
                          </Nav.Item>
                        </span>
                        {Array.isArray(agentsContainer?.data) === false && agentsContainer?.data != null && (
                          <>
                            {Object.entries(agentsContainer.data).map(([mainName, subItems], index) => (
                              <span key={index}>
                                <Nav.Item>
                                  <Nav.Link style={{ display: 'flex' }}>
                                    <FontAwesomeIcon icon={faTasks} className="mt-3" />
                                    <SubMenu
                                      title={
                                        <>
                                          <span className="px-1 mt-1">{mainName}</span>
                                        </>
                                      }
                                      items={[
                                        <Nav
                                          className="flex-column pt-2"
                                          onSelect={(key) => setSelectedItem(key)}
                                          activeKey={selectedItem}
                                        >
                                          {subItems.map((menuItem, subIndex) => (
                                            <span key={subIndex}>
                                              <hr className="my-0" />
                                              <Nav.Item key={menuItem.key}>
                                                <Nav.Link as={Link} to={`/soc/dashboard?agentname=${menuItem.name}&agentid=${menuItem.id}`}>
                                                  <img
                                                    src="/assets/icons/over-all.svg"
                                                    className="nav-dimension-icon"
                                                    alt="menuItem-icon"
                                                  />
                                                  {menuItem.name}
                                                </Nav.Link>
                                              </Nav.Item>
                                            </span>
                                          ))}
                                        </Nav>,
                                      ]}
                                    />
                                  </Nav.Link>
                                </Nav.Item>
                              </span>
                            ))}
                          </>
                        )}
                      </Nav>,
                    ]}
                  />
                </span>
                {(loginuser === "Super Admin" &&
                  <>
                    <span>
                      <Nav.Item key="agents">
                        <Nav.Link as={Link} to="/soc/report-management">
                          <FontAwesomeIcon icon={faTh} />
                          <span className="px-1">Report Management</span>
                        </Nav.Link>
                      </Nav.Item>
                    </span>
                    <span>
                      <Nav.Item key="socreportdownload">
                        <Nav.Link
                          onClick={() =>
                            setIsSOCReportDownlaod(!isSOCReportDownload)
                          }
                        >
                          <FontAwesomeIcon icon={faTh} />
                          <span className="px-1"> Download Report</span>
                        </Nav.Link>
                      </Nav.Item>
                    </span>
                  </>
                )}
              </Nav>,
            ]}
          />
        </span>
      )}
      {loginuser &&
        (activeMainItem === null ||
          activeMainItem === "threat-intelligence") && (
          <span>
            <SubMenu
              title={
                <Tooltip title="Threat Intelligence Platform" placement="top">
                  <span className="px-2">Threat Intelligence</span>
                </Tooltip>
              }
              onClick={() =>
                handleMainItemClick("threat-intelligence", "/tip/dashboard")
              }
              icon={faChartBar}
              expand="false"
              items={[
                <Nav
                  className="flex-column pt-2"
                  onSelect={handleSelect}
                  activeKey={selectedItem}
                >
                  <Nav.Item key="tipdashboard">
                    <Nav.Link as={Link} to="/tip/dashboard">
                      <FontAwesomeIcon
                        icon={faTachometerAlt}
                        className="mr-2"
                      />
                      <span className="px-1"> Dashboard </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item key="tipuserguide">
                    <Nav.Link as={Link} to="/tip/user-guide">
                      <FontAwesomeIcon icon={faGlobe} className="mr-2" />
                      <span className="px-1"> User guide </span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>,
              ]}
            />
          </span>
        )}
      {isSummaryReportOpen && (
        <SummaryReport
          toggleSummaryReport={() =>
            setIsSummaryReportOpen(!isSummaryReportOpen)
          }
        />
      )}
      {isRequestNewScanOpen && (
        <RequestNewScanECS
          toggleRequestNewScan={() =>
            setIsRequestNewScanOpen(!isRequestNewScanOpen)
          }
        />
      )}
      {isViewReportOpen && (
        <ViewReport
          toggleViewReport={() => setIsViewReportOpen(!isViewReportOpen)}
        />
      )}
      {isRsRequestNewScanOpen && (
        <RSRequestNewScan
          toggleRequestNewScan={() =>
            setRsIsRequestNewScanOpen(!isRsRequestNewScanOpen)
          }
        />
      )}
      {isRsViewReportOpen && (
        <RSViewReport
          toggleViewReport={() => setRsIsViewReportOpen(!isRsViewReportOpen)}
        />
      )}
      {isVAPTViewReportOpen && (
        <ViewReportPage
          toggleViewReport={() =>
            setVAPTIsViewReportOpen(!isVAPTViewReportOpen)
          }
        />
      )}
      {isVAPTRequestNewScanOpen && (
        <VAPTRequestNewScan
          toggleRequestNewScan={() =>
            setVAPTIsRequestNewScanOpen(!isVAPTRequestNewScanOpen)
          }
        />
      )}
      {isVAPTSummaryReportOpen && (
        <ViewReportVAPT
          toggleRequestNewScan={() =>
            setVAPTIsSummaryReportOpen(!isVAPTSummaryReportOpen)
          }
        />
      )}
      {isSOCReportDownload && (
        <DownloadSOCReport
          toggleReportDownload={() =>
            setIsSOCReportDownlaod(!isSOCReportDownload)
          }
        />
      )}
      <Dialog
        open={chooseDialog}
        onClose={() => setChooseDialog(false)}
        aria-labelledby="delete-dialog-title"
      >
        <DialogTitle align="center">
          Choose customer type
          <Divider className="divider" />
        </DialogTitle>
        <DialogActions className="m-3">
          <Button
            className="MuiButton-contained"
            onClick={() => {
              navigate(`/add-partnercompany`, {
                state: { customertype: "Partner" },
              });
              setChooseDialog(false);
            }}
          >
            PARTNER
          </Button>
          <Button
            className="MuiButton-contained"
            onClick={() => {
              navigate(`/add-partnercompany`, {
                state: { customertype: "endcustomer" },
              });
              setChooseDialog(false);
            }}
          >
            END CUSTOMER
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SideBar;
